import { isEqual } from "lodash-es"
import { OverallStats as BackendOverallStats } from "@longtail-education/superprepstudy-data-model-frontend"

/**
 * Represents overall statistics with extended functionality for the frontend.
 */
export class OverallStats extends BackendOverallStats {
  /**
   * Checks if two OverallStats objects are equal.
   * @param a The first OverallStats object.
   * @param b The second OverallStats object.
   * @returns A boolean indicating whether the two objects are equal.
   */
  static isEqual(a: OverallStats | undefined, b: OverallStats | undefined): boolean {
    return isEqual(a, b)
  }
}
